import { apiClient, ApiResponse } from './client'

export interface SendPhoneCodeRequest {
  countryCode: string
  phoneNumber: string
}
export interface SendCodeResponse {
  expiresInSeconds: number
}
export interface VerifyPhoneCodeRequest {
  countryCode: string
  phoneNumber: string
  code: string
}
export interface VerifyCodeResponse {
  verified: boolean
  verificationToken: string
}
export interface UpdatePhoneRequest {
  countryCode: string
  phoneNumber: string
  verificationToken: string
}
export interface UpdatePhoneResponse {
  phoneNumber: string
  countryCode: string
  isPhoneVerified: boolean
}

export const phoneApi = {
  sendCode: (data: SendPhoneCodeRequest) =>
    apiClient.post<ApiResponse<SendCodeResponse>>('/phone/send-code', data),

  verifyCode: (data: VerifyPhoneCodeRequest) =>
    apiClient.post<ApiResponse<VerifyCodeResponse>>('/phone/verify-code', data),

  updatePhone: (data: UpdatePhoneRequest) =>
    apiClient.put<ApiResponse<UpdatePhoneResponse>>('/phone/update', data),
}
